import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../diccionarios/comisionesModulo';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AsignacionDistribucionIncentivosService {

  diccionarioUrl: any;
  urlMaestros: string;
  urlComisiones: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlMaestros = this.utilServices.getDatosMaestros();
    this.urlComisiones = this.utilServices.getComisiones();
    this.diccionarioUrl = comisionesModulo.url.asignacionDistribucionIncentivos;
  }

  getTodo() {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerTodo);
  }

  getPorId(id) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPorId + id);
  }

  getTodoPorTipoDeVendedor(idVendedor) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPorTipoDeVendedor + idVendedor);
  }

  save(innObj: any) {
    console.log("saveTipoDeVendedore", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.crear, innObj);
  }

  update(innObj: any) {
    console.log("updateTipoDeVendedore", innObj)
    return this.commom.peticionPutConHeader(this.urlComisiones + this.diccionarioUrl.actualizar, innObj);
  }

  delete(innObj: any) {
    return this.commom.peticionDeleteConHeader(this.urlComisiones + this.diccionarioUrl.eliminar, innObj);
  }
  
  procesarCsv(formData: FormData): Observable<any[]> {
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.recepcionCsv, formData);
  }

  saveCsv(listObj: any[]) { //
    console.log("saveCsvIndicadores", listObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.recepcionCsvSave , listObj);
  }

}
